export default (main_locale: null | number, localization: any, default_text: string | null, text_key: string) => {
    let displayed_text = default_text;
    for (let i = 0; i < localization.length; i++) {
        if (localization[i].locale === main_locale) {
            if (localization[i][text_key]) {
                displayed_text = localization[i][text_key];
            }
        }
    }
    return displayed_text === null ? '' : displayed_text;
};